import { isApiError, isApiErrorHandled } from "@/services/api/types";

/**
 * Net global para `onunhandledrejection`.
 *
 * Alguns `ApiError` são tratados (toast via `notifyError`) mas, por serem
 * re-lançados em contextos que o Vue não aguarda (event handlers async,
 * fire-and-forget), a rejeição escapa como `onunhandledrejection` — virando
 * ruído no console e no Sentry (AI-977).
 *
 * Aqui suprimimos APENAS os `ApiError` já marcados como tratados. Erros
 * genuinamente não-tratados (nunca exibidos ao usuário) NÃO são marcados e
 * continuam propagando normalmente — bugs reais permanecem visíveis.
 *
 * Idempotente: registra o listener uma única vez.
 */
let installed = false;

export function installUnhandledRejectionHandler(): void {
  if (installed || globalThis.window === undefined) return;
  installed = true;

  globalThis.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    if (isApiError(event.reason) && isApiErrorHandled(event.reason)) {
      // Já tratado/exibido: evita o erro de console e a captura pelo Sentry.
      event.preventDefault();
    }
  });
}
